import { Directive, Input, TemplateRef } from '@angular/core';

/** Supplies the body template for one app-data-table column. */
@Directive({
  selector: 'ng-template[dtCell]',
  standalone: true,
})
export class DataTableCellDirective<T = unknown> {
  @Input('dtCell') columnId = '';

  constructor(readonly template: TemplateRef<{ $implicit: T }>) {}
}
